import { dataExcellentBookmark } from 'dls-icons-data'
import { createIcon } from '../common'

const IconExcellentBookmark = /*#__PURE__*/createIcon(dataExcellentBookmark)
export default IconExcellentBookmark
